/**
 * Identifies which CSF surface a Dynamic Commissioning (DC) Add-to-Basket
 * event originated from. Used as an explicit parent-owned eligibility gate:
 * a surface must set `dynamicCommissioningAtbSource` to one of these values
 * for `AddToBasketButton` to fire DC ATB analytics and update the active
 * commissioning U1/siteId pair. Surfaces that do not set it are descoped
 * by default.
 *
 * Source: Eduardo Gutierrez (DC architecture owner), CSF-1851 review,
 * 2026-05-28 — replaces the implicit `!motomProductId` gate with explicit
 * source identity to keep telemetry-ready slicing without future migrations.
 *
 * BESTSELLERS_CAROUSEL added in CSF-1891 (Eduardo, 2026-06-30) — the CSF
 * Bestsellers carousel is Constructor.io / RecService-fed and its products
 * typically do not carry `motomProductId`. When this source is set, the DC
 * U1 update ALWAYS uses the literal `"bestseller"` sentinel as the second
 * segment of `identifierLocation` (the sentinel wins even if the product
 * happens to carry a `motomProductId`, so U1 slicing stays consistent for
 * this surface). The event payload's `motom_product_id` is independent of
 * the sentinel: it is passed through from `product.motomProductId` (or
 * `null` when the product truly has no motom id — the common Bestsellers
 * case). The enum name intentionally omits the vendor because the same
 * CSF surface can be backed by either carousel implementation depending
 * on the `recsMigration` config.
 */
export const CSF_DC_ATB_SOURCES = {
    PRODUCT_GRID: 'PRODUCT_GRID',
    POST_DETAILS: 'POST_DETAILS',
    BESTSELLERS_CAROUSEL: 'BESTSELLERS_CAROUSEL'
};

/**
 * Sentinel value written to the second segment of the U1 identifierLocation
 * when a DC ATB originates from a source that does not have a product-level
 * identifier (currently only the Bestsellers carousel; see CSF-1891). Passed
 * to `applyProductInteractionToActiveCommissioningU1` as `identifierOverride`.
 */
export const CSF_DC_U1_BESTSELLER_SENTINEL = 'bestseller';
